import { storeToRefs } from 'pinia'
import { usePermissionsStore } from '@/stores/permissions'

export function usePermissions() {
  const store = usePermissionsStore()
  const { codes, loading, lastFetch } = storeToRefs(store)

  return {
    codes,
    loading,
    lastFetch,
    hasPermission: store.has,
    hasAnyPermission: store.hasAny,
    hasAllPermissions: store.hasAll,
    can: store.can,
    canAny: store.canAny,
    canAll: store.canAll,
    fetchPermissions: store.fetchPermissions,
    clearPermissions: store.clear,
    hydrate: store.hydrate,
  }
}
